import React, { useContext, useState, useCallback } from 'react'
import { VLPTopCategories, UserInfoMsg } from '@usap/widgets'
import { Box, InfoOutlineIcon, useResponsiveWrapperContext } from '@usap/uicomponents'

import { InView } from 'react-intersection-observer'

import { LocalContext } from '../../helpers/useLocalContext'
import getCategoryParts from '../../helpers/getCategoryParts'

import { DynamicDataContext } from '../../contexts/dynamicData.context'

const style = {
  margin: { vertical: '0px', horizontal: 'auto' },
  pad: { horizontal: 'small' },
}

export default function TopCategories(props) {
  const {
    dynamicApiData: { vehicle, categoryPart },
  } = props

  const [partList, setPartList] = useState({})
  const [loading, setLoading] = useState(false)

  const { setInView } = useContext(DynamicDataContext)
  const { localContext } = useContext(LocalContext)
  const { isDesktop } = useResponsiveWrapperContext()
  const { Link } = localContext

  const selVName = vehicle
    ? `${vehicle.year} ${vehicle.make} ${vehicle.model} ${
      vehicle.submodel ? vehicle.submodel : ''
    } ${vehicle.engine ? vehicle.engine : ''}`
    : ''

  const handleCategoryPartsonClick = useCallback((url, link) => {
    if (partList[link] && partList[link].length) {
      return ''
    }

    setLoading(true)
    return getCategoryParts(url)
      .then(resp => {
        if (
          resp &&
          resp.data &&
          resp.data.data &&
          resp.data.data.categoryParts
        ) {
          setPartList({ ...partList, [link]: resp.data.data.categoryParts })
        }
      })
      .catch(error => {
        throw error
      })
      .finally(() => {
        setLoading(false)
      })
  }, [partList])

  if (!categoryPart || !Object.keys(categoryPart).length) {
    return (
      <Box
        margin={style.margin}
        width="1248px"
        pad={style.pad}
      >
        <UserInfoMsg
          bgColor="orange"
          icon={InfoOutlineIcon}
          infoType="We do not have any compatible categories for your vehicle."
        />
      </Box>
    )
  }

  return (
    <Box margin={style.margin}>
      <VLPTopCategories
        categoryPart={categoryPart}
        isDesktop={isDesktop}
        selVName={selVName}
        Link={Link}
        handleCategoryPartsonClick={handleCategoryPartsonClick}
        loading={loading}
        partList={partList}
      />
      <InView
        key="belowTheFold"
        triggerOnce
        onChange={setInView}
      />
    </Box>
  )
}
